import React, {Component} from 'react';
import {history} from "./helpers/history";
import {Router, Route, Redirect} from "react-router-dom";
import {PrivateRoute}  from "./components/PrivateRoute";
import PanelPage from "./layouts/Panel/PanelPage";
import LoginPage from "./layouts/Account/LoginPage/LoginPage";
import {connect} from 'react-redux';
import NotPermissionPage from "./layouts/NotPermissionPage";
import PilotStandardPage from "./layouts/PilotStandard/PilotStandardPage";

class App extends Component {

    componentDidMount() {
        const scrollData = {};
        const { push, replace } = history;

        // Override the history PUSH method to automatically set scroll state.
        history.push = (path, state = {}) => {
            scrollData[history.location.pathname] = window.scrollY;
            push(path, state);
        };

        // Override the history REPLACE method to automatically set scroll state.
        history.replace = (path, state = {}) => {
            scrollData[history.location.pathname] = window.scrollY;
            replace(path, state);
        };

        // Listen for location changes and set the scroll position accordingly.
        history.listen((location, action) => {
            if(location.state?.fromDashboard) {
                scrollData[location.pathname] = 0;
            }
            setTimeout(() => {
                window.scrollTo(
                    0,
                    action === 'POP' ? 0 : scrollData[location.pathname] ?? 0,
                );
            }, 500);
        });

    }

    render() {
        return (
            <div className="App">
                <Router history={history}>
                        <div>
                            <Route exact path='/'>
                                <Redirect to="/panel" />
                            </Route>
                            <PrivateRoute  path='/panel' component={PanelPage} />
                            <Route path='/login' component={LoginPage} />
                            <Route path='/not-permissions' component={NotPermissionPage} />
                            <Route path='/pilot' component={PilotStandardPage} />
                        </div>
                </Router>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { alert } = state;
    return {
        alert
    };
};

export default connect(mapStateToProps)(App);
